// extracted by mini-css-extract-plugin
export default {"content":"ErrorPage_content__s4eff","Error":"ErrorPage_Error__DQ6UH","cta":"ErrorPage_cta__hVixl","Description":"ErrorPage_Description__PptRg"};